<template>
  <div class="portrait_fans">
    <div class="avatar-info">
      <img class="avatar" :src="kolUserXt.avatarUri" v-if="kolUserXt.avatarUri"/>
      <div style="width: 100%">
        <div class="flex-box">
          <div class="nickname">{{ kolUserXt.nickname }}
            <i class="el-icon-male" style="color:blue; margin-right: 5px;" v-if="kolUserXt.gender ==1"></i>
            <i class="el-icon-female" style="color:pink; margin-right: 5px;" v-if="kolUserXt.gender ==2"></i>
            <span class="daren-tag"
              v-for="(item, index) in kolUserXt.tags"
              :key="index">{{ item }}</span>
          </div>
          <el-button type="text" size="medium" style="padding: 0" icon="el-icon-refresh-right"
            @click="updateKolInfo">更新达人信息</el-button>
        </div>
        <div class="info">
          <span>{{ kolUserXt.uniqueId ? kolUserXt.uniqueId:kolUserXt.shortId }}</span>
          <span>总商品数：{{million(kolUserXt.goodsNum)}}</span>
        </div>
        <div class="info">
          <span>粉丝总数：{{million(kolUserXt.follower)}}</span>
          <span>直播总销量：{{million(kolUserXt.liveSalesNum)}}</span>
        </div>
        <div class="info">
          <span>总点赞数：{{million(kolUserXt.receiveLikeNum)}}</span>
          <span>直播总销售额：{{million(kolUserXt.liveSalesValue)}}</span>
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="empty-area" v-if="!haveValue">
      <div class="empty-img"></div>
      <div class="empty-font">暂无数据</div>
    </div>
    <!-- 粉丝分析 -->
    <div class="chars-box" v-if="haveValue && isfans">
      <div class="title">粉丝分析</div>
      <ve-line class="chart-canvas" 
        :data="dFansChart"
        :legend-visible="false"
        :settings="dFansChartsetting"
        :extend="dFansChartextend"></ve-line>
      <!-- <div id="dFansChart" class="chart-canvas"></div> -->
    </div>
    <!-- 省份分布 -->
    <div class="chars-box" v-if="haveValue && isprovince">
      <div class="title">省份分布</div>
      <ve-histogram class="chart-canvas"
        :data="dProvinceChart"
        :settings="dProvinceChartsetting"
        :extend="dProvinceChartExtend"></ve-histogram>
      <!-- <div id="dProvinceChart" class="chart-canvas"></div> -->
    </div>
    <!-- 性别/年龄分布 -->
    <div class="chars-flex">
      <div class="chars-box" v-if="haveValue && isgender">
        <div class="title">性别分布</div>
        <ve-ring class="chart-canvas"
          :data="dGenderChart"
          :legend-visible="false"
          :settings="dGenderChartsetting"
          :extend="dGenderChartextend"></ve-ring>
      <!-- <div id="dGenderChart" class="chart-canvas"></div> -->
      </div>
      <div class="chars-box" v-if="haveValue && isage">
        <div class="title">年龄分布</div>
        <ve-histogram class="chart-canvas"
          :data="dAgeChart"
          :settings="dProvinceChartsetting"
          :extend="dProvinceChartExtend"></ve-histogram>
        <!-- <div id="dAgeChart" class="chart-canvas"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import echartConf from "@/config/echartConf.js"
export default {
  name: "portrait_fans",
  components:{},
  props: {
    fansObj: {
      luopan_id: 0
    }
  },
  data() {
    this.dFansChartsetting = {
      min: [0, 0]
    }
    this.dFansChartextend = {
      color: echartConf.lineColor
    }
    this.dProvinceChartsetting = {
      yAxisType: ['percent']
    }
    this.dProvinceChartExtend = {
      color: echartConf.multipleColor,
      tooltip: echartConf.tooltip,
      series: {
        barWidth: 40
      }
    }
    this.dGenderChartsetting = {
      dataType: 'percent'
    }
    this.dGenderChartextend = {
      color: echartConf.multipleColor
    }
    return {
      haveValue: false,
      isfans: false,
      isprovince: false,
      isgender: false,
      isage: false,
      dFansChart: {
        columns: ['日期', ''],
        rows: []
      },
      dProvinceChart: {
        columns: ['省份', ''],
        rows: []
      },
      dGenderChart: {
        columns: ['name', 'value'],
        rows: []
      },
      dAgeChart: {
        columns: ['年龄', ''],
        rows: []
      },
      kolUserXt: {
        avatarUri: "",
        nickname: "",
        tags: [],
        shortId: [],
        goodsNum: 0,
        follower: 0,
        liveSalesNum: 0,
        receiveLikeNum: 0,
        liveSalesValue: 0
      },
      apiUrl: {
        redirectJavaApi: "/home/redirectJavaApi"
      }
    }
  },
  created() {},
  mounted() {
    this.getBase();
    this.getFans();
    // this.fansFunc();
    // this.provinceFunc();
    // this.ageFunc();
    // this.genderFunc();
  },
  methods: {
    fansFunc(res) {
      let key = res.key;
      let value = res.value;
      // let key = ["2020-01-31","2020-02-01","2020-02-02","2020-02-03","2020-02-04","2020-02-05","2020-02-06","2020-02-07","2020-02-08","2020-02-09","2020-02-10","2020-02-11","2020-02-12","2020-02-13","2020-02-14","2020-02-15","2020-02-16","2020-02-17","2020-02-18","2020-02-19","2020-02-20","2020-02-21","2020-02-22","2020-02-23","2020-02-24","2020-02-25","2020-02-26","2020-02-27","2020-02-28","2020-02-29","2020-03-01","2020-03-02","2020-03-03","2020-03-04","2020-03-05","2020-03-06","2020-03-07","2020-03-08","2020-03-09","2020-03-10","2020-03-11","2020-03-12","2020-03-13","2020-03-14","2020-03-15","2020-03-16","2020-03-17","2020-03-18","2020-03-19","2020-03-20","2020-03-21","2020-03-22","2020-03-23","2020-03-24","2020-03-25","2020-03-26","2020-03-27","2020-03-28","2020-03-29","2020-03-30","2020-03-31","2020-04-01","2020-04-02","2020-04-03","2020-04-04","2020-04-05","2020-04-06","2020-04-07","2020-04-08","2020-04-09","2020-04-10","2020-04-11","2020-04-12","2020-04-13","2020-04-14","2020-04-15","2020-04-16","2020-04-17","2020-04-18","2020-04-19","2020-04-20","2020-04-21","2020-04-22","2020-04-23","2020-04-24","2020-04-25","2020-04-26","2020-04-27","2020-04-28","2020-04-29"];
      // let value = [2045375,2045396,2044488,2043465,2042403,2041479,2045586,2055024,2057569,2062892,2067307,2069622,2072529,2074299,2075645,2080070,2084394,2088531,2090345,2090611,2092357,2093189,2093877,2093431,2092902,2093199,2093222,2093343,2092811,2093848,2095746,2096017,2095572,2095450,2095319,2118162,2130549,2138372,2143929,2143625,2146943,2146261,2145960,2147494,2147721,2147461,2146681,2146375,2145529,2144997,2145423,2144946,2144673,2146341,2148515,2148397,2147960,2147616,2147199,2146705,2146423,2146089,2146640,2149852,2148141,2148682,2149672,2149584,2149451,2148968,2148625,2148357,2148412,2148256,2153227,2154626,2177189,2188172,2190089,2194891,2198158,2227034,2242720,2287270,2306286,2319407,2323791,2327948,2334276,2339522];
      let rowArr = [];
      for(let i = 0; i < key.length; i++) {
        for (let j = 0; j < value.length; j++) {
          let row = {}
          if (i === j) {
            row['日期'] = key[i];
            row[''] = value[j];
            rowArr.push(row);
          }
        }
      }
      this.dFansChartsetting.min = [res.min, res.min]
      // this.dFansChartsetting.min = [2041479, 2041479]
      this.dFansChart.rows = rowArr;
    },
    provinceFunc(res) {
      let key = res.key;
      let value = res.value;
      // let key = ["北京","四川","山东","广东","江苏","河南","浙江","湖北","湖南","重庆"];
      // let value = ["3.9%","17.14%","4.4%","11.09%","5.49%","3.86%","5.03%","3.46%","3.22%","3.75%"];
      let rowArr = [];
      for(let i = 0; i < key.length; i++) {
        for (let j = 0; j < value.length; j++) {
          let row = {}
          if (i === j) {
            row['省份'] = key[i];
            row[''] = parseFloat(value[j]) / 100;
            rowArr.push(row);
          }
        }
      }
      this.dProvinceChart.rows = rowArr;
    },
    ageFunc(res) {
      let key = res.key;
      let value = res.value;
      // let key = ["18-24","25-30","31-35","36-40","41+","6-17"];
      // let value = ["40.34%","33.37%","12.65%","4.28%","4.32%","5.04%"];
      let rowArr = [];
      for(let i = 0; i < key.length; i++) {
        for (let j = 0; j < value.length; j++) {
          let row = {}
          if (i === j) {
            row['年龄'] = key[i];
            row[''] = parseFloat(value[j]) / 100;
            rowArr.push(row);
          }
        }
      }
      this.dAgeChart.rows = rowArr;
    },
    genderFunc(res) {
      let res1 = res;
      // let res1 = [{"name":"男","value":"78.75%"}];
      for(let i = 0; i < res1.length; i++) {
        res1[i].value = parseFloat(res1[i].value) / 100;
      }
      this.dGenderChart.rows = res1;
    },
    //基础数据
    getBase() {
      let data = {
        id: this.fansObj.luopan_id,
        "request_api_info": '/kol/detail/base_post'
      }
      this
        .$http({
          method: "GET",
          url: this.apiUrl.redirectJavaApi,
          params: data
        })
        .then(res => {
          if (res.code == 1 && res.data) {
            this.kolUserXt = res.data;
            if(res.data.tags){
              let kolTags = res.data.tags;
              kolTags = kolTags.replace(/\"|\[|\]|\s/g, "").replace(/\\/g, "%");
              kolTags = unescape(kolTags);
              kolTags = kolTags.split(',');
              this.kolUserXt.tags = kolTags;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //粉丝分析
    getFans() {
      let data = {
        id: this.fansObj.luopan_id,
        "request_api_info": '/kol/detail/fans_post'
      }
      this
        .$http({
          method: "GET",
          url: this.apiUrl.redirectJavaApi,
          params: data
        })
        .then(res => {
          if (res.code == 1 && res.data) { 
            this.haveValue = true;
            // 粉丝分析
            if(res.data.fansTrend) {
              this.fansFunc(res.data.fansTrend);
              this.isfans = true;
              // _this.fansOption.xAxis.data = res.data.fansTrend.key
              // _this.fansOption.series[0].data = res.data.fansTrend.value
              // _this.fansOption.yAxis.min = res.data.fansTrend.min
              // _this.chartArr[0].show = true
            }
            // 省份分布
            if(res.data.province) {
              this.provinceFunc(res.data.province);
              this.isprovince = true;
              // let arrProvince = []
              // res.data.province.value.forEach((item)=>{
              //   arrProvince.push(item.replace(/\%/g,""))
              // })
              // _this.provinceOption.xAxis[0].data = res.data.province.key
              // _this.provinceOption.series[0].data = arrProvince
              // _this.chartArr[1].show = true
            }
            // 年龄分布
            if(res.data.age) {
              this.ageFunc(res.data.age);
              this.isage = true;
              // let arrAge= []
              // res.data.age.value.forEach((item)=>{
              //   arrAge.push(item.replace(/\%/g,""))
              // })
              // _this.ageOption.xAxis[0].data = res.data.age.key
              // _this.ageOption.series[0].data = arrAge
              // _this.chartArr[2].show = true
            }
            // 性别分布
            if(res.data.gender) {
              this.genderFunc(res.data.gender);
              this.isgender = true;
              // let arrGender = []
              // res.data.gender.forEach((item)=>{
              //   obj = {
              //     name: item.name,
              //     value: item.value.replace(/\%/g,"")
              //   }
              //   arrGender.push(obj)
              // })
              // _this.genderOption.series[0].data = arrGender
              // _this.sexDescription = res.data.genderDescription || ''
              // _this.chartArr[3].show = true
            }
          } else {
            this.haveValue = false;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 更新达人
    updateKolInfo(){
      let data = {
        "request_api_info": '/kol/updateDyKol_post',
        id: this.fansObj.luopan_id,
      }
      this.$http({
        method: "GET",
        url: this.apiUrl.redirectJavaApi,
        params: data
      }).then(res => {
        if (res.code == 1) {
          this.$message.success('数据获取需要一定时间，可稍后再来查看数据。')
        }else{
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err);
      });
    },
    //过万处理
    million (value){
      let num;
      if(value > 9999){
        num = Number((value/10000).toFixed(2))+'w'
        return num;
      }
      return value;
    }
  }
}
</script>
<style scoped>
.portrait_fans {
  padding-top: 25px;
}
.flex-box,
.chars-flex,
.avatar-info {
  display: flex;
}
.flex-box {
  justify-content: space-between;
}
.info {
  font-size: 14px;
  color: #666;
  line-height: 28px;
}
.info > span {
  display: inline-block;
  width: 150px;
  margin-right: 87px;
}
.chars-box {
  width: 100%;
}
.chars-flex .chars-box {
  width: 50%;
}
.chars-box .title {
  font-size: 20px;
  color: #252328;
  position: relative;
}
.chars-box .title::before {
  content: "";
  height: 20px;
  width: 3px;
  background-color: #6435E8;
  position: absolute;
  left: -20px;
  top: 4px;
}
.avatar {
  width: 100px;
  height: 100px;
  border-radius: 6px;
  margin-right: 16px;
}
.nickname {
  font-size: 14px;
  color: #333;
  margin-right: 10px;
}
.chart-canvas {
  width: 100%;
  height: 300px;
}
.empty-area {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.empty-img {
  width: 100px;
  height: 74px;
  margin-top: 83px;
  background: url("../../assets/my/null.png") no-repeat center;
  background-size: cover;
}
.empty-font {
  font-size: 14px;
  color: #666;
  margin: 10px 0 0 0;
}
</style>